import { useNavigate } from "react-router-dom";
import logo from "../../Assets/images/logo.png";
import { BillingComponent} from "./BillingComponent";
import "../../Style/scss/pages/dashboard.scss";
import { WarningModel } from "../../Model/WarningModel";

export const Billing = () => {
    const navigate = useNavigate();
    const handleContinue = () => {
        navigate("/payment");
    }
  return (
    <>
    <section className="layoutContainer layoutContainer--full">
      <div className="layoutGrid">
        <div className="page page--loginOtp">
          <div className="page__head">
            <div className="page__head__logo">
              <img src={logo} alt="Logo | Vox App" />
            </div>
            <div className="page__head__actions">
              <button className="backBtn" onClick={handleContinue}>
                Continue
                <svg
                  width="10"
                  height="18"
                  viewBox="0 0 10 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.5 16L8.5 9L1.5 2"
                    stroke="#8b58f1"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>
        <BillingComponent/>
        </div>
      </div>
    </section>
    </>
  );
};
